var _circle, _circle2, _circle3, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNewsletterWidget1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20.2,
    cy: 20,
    r: 20,
    fill: "#EB94BE"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 40.2,
    cy: 20,
    r: 20,
    fill: "#FBBC99"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 29.8,
    cy: 40,
    r: 20,
    fill: "#A6CEE3"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.2 37.3244C36.178 33.8663 40.2 27.4028 40.2 20C40.2 12.5972 36.178 6.13375 30.2 2.67566C24.222 6.13375 20.2 12.5972 20.2 20C20.2 27.4028 24.222 33.8663 30.2 37.3244Z",
    fill: "#E76D72"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.99396 37.2035C11.3542 27.4817 19.7034 20 29.8 20C33.5282 20 37.0182 21.0201 40.006 22.7965C38.6458 32.5183 30.2966 40 20.2 40C16.4718 40 12.9818 38.9799 9.99396 37.2035Z",
    fill: "#9978A9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.3395 22.3746C23.1562 20.8596 26.3777 20 29.8 20C40.0423 20 48.4863 27.699 49.6605 37.6254C46.8439 39.1404 43.6223 40 40.2 40C29.9578 40 21.5138 32.301 20.3395 22.3746Z",
    fill: "#A39888"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.0061 22.7965C37.4479 21.2756 34.5216 20.309 31.3928 20.0625C30.8674 20.0211 30.3362 20 29.8 20C29.169 20 28.5448 20.0292 27.9287 20.0864C27.185 20.1554 26.4532 20.2651 25.7355 20.4133C23.8228 20.8081 22.01 21.4761 20.3395 22.3746C21.0962 28.7705 24.8709 34.2416 30.2 37.3244C35.4117 34.3096 39.1366 29.0107 40.0061 22.7965Z",
    fill: "#965865"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewsletterWidget1);
export default __webpack_public_path__ + "static/media/newsletterWidget1.9e4b6d2e1703ae5a4978b15c74a187b7.svg";
export { ForwardRef as ReactComponent };